<template>
  <div class="about">
    <div class="ani logo" swiper-animate-effect="fadeIn" swiper-animate-duration="0.5s">
      <a href="#home"><img src="../assets/logo.png"></a>
    </div>
    <div class="about-con">
      <div class="about-img">
        <div class="pc-img">
          <img class="ani" swiper-animate-effect="fadeInLeft" swiper-animate-duration="1s" src="../assets/image4.jpg">
        </div>
        <!-- <div class="m-img">
          <img class="ani" swiper-animate-effect="fadeInLeft" swiper-animate-duration="1s" src="../assets/image5.jpg">
        </div> -->
      </div>
      <div class="about-text">
        <div class="about-title">
          <h2
            class="ani"
            swiper-animate-effect="fadeInUp"
            swiper-animate-duration="1.5s"
          >HUNICORN GROUP</h2>
        </div>
        <div class="about-p">
          <p
            class="ani"
            swiper-animate-effect="fadeInUp"
            swiper-animate-duration="1.5s"
            swiper-animate-delay="0.3s"
          >Hunicorn Group is a key player in Asia for freight forwarding and logistics solution. It was founded in 2004, with headquarter in Shenzhen, a fast-growing modern city. Now the group has over 500 staffs, and more than 30 branches in Far east. We are providing air, ocean, truck and railway transportation services. We have developed as well value-added services such as customs, warehouse management, supply chain solutions.</p>
          <p
            class="ani"
            swiper-animate-effect="fadeInUp"
            swiper-animate-duration="1.5s"
            swiper-animate-delay="0.5s"
          >OUR VISION: Together We Deliver
          <br />We deliver goods, based on customers’ requirements. 
          <br />We deliver what we promised to our clients. 
          <br />We have a long-term vision together with all our teammates. 
          <br />We are ecofriendly and wish to contribute to the society, to our country and to the world.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "about",
  data() {
    return {};
  },
  components: {}
};
</script>

<style>
.about,
.about-con {
  height: 100%;
}
.about-img {
  float: left;
  width: 50%;
  height: 100%;
  position: relative;
  background: #367ad8;
}
.about-img div {
  position: absolute;
  right: -10%;
  top: 50%;
  width: 70%;
  transform: translateY(-50%);
}
.about-img div img {
  width: 100%;
}
.about-img .m-img{
  display: none;
}
.about-text {
  float: right;
  width: 50%;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}
.about-title h2 {
  padding: 40px 0 30px 0;
  font-size: 56px;
  text-align: center;
  background: url(../assets/about.png) no-repeat left 120px top;
}
.about-p {
  max-width: 500px;
  margin: 0 auto;
  font-size: 16px;
  color: #666;
  line-height: 1.8;
}
.about-p p {
  margin-bottom: 30px;
}
@media screen and (max-width: 992px) {
  .about-img {
    width: 100%;
    height: 20%;
  }
  .about-img .pc-img{
    display: none;
  }
  .about-img .m-img{
    display: block;
  }
  .about-text {
    float: none;
    width: 50%;
    position: relative;
    top: 0;
    right: 0;
    transform: translateY(0%);
  }  
  .about-text {
    width: 100%;
  }
  .about-img {
    height: 30%;
    float: none;
  }
  .about-text {
    margin-top: -65px;
  }
  .about-img div {
    top: 85%;
    width: 280px;
    left: 50%;
    margin-left: -140px;
    right: auto;
  }
  .about-title h2 {
    font-size: 30px;
    color: #fff;
    background-size: 70%;
    background-position: center;
    padding: 15px 0;
  }
  .about-p p {
    line-height: 1.5;
    font-size: 14px;
    margin-bottom: 0;
    padding: 0 20px;
  }
  .body-swiper .swiper-pagination{
    font-size: 18px;
  }
  .swiper-pagination .swiper-pagination-bullet-active{
    padding-bottom: 46px;
    margin-top: 0px !important;
  }
  .swiper-pagination .swiper-pagination-bullet-active::before{
    height: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/About.vue